import Logo from "../../assets/images/logo.png"

export default function Loading({ message = "Loading", fullPage = false }) {
    return (
        <div className={`flex items-center justify-center ${fullPage ? "min-h-screen" : "h-full"}`}>
            <div className="flex flex-col items-center gap-4">
                <img src={Logo} alt="Tickets.NP logo" className="w-20 object-contain" />
                <div className="flex items-center gap-2">
                    <span className="h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-gray-500"/>
                    <p className="text-sm text-gray-500">
                        {message}
                    </p>
                </div>
            </div>
        </div>
    );
}